import { post } from '../../utils/http';

export const createConfirmation = ({ accountId, branchId, projectId, shiftIds, message }) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/confirmations`, {
    shifts: shiftIds,
    message
  });

export const resendConfirmations = ({ accountId, branchId, projectId }) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/confirmations/resend`);
